(function () {
  const widgets = document.querySelectorAll('[data-advisory-form]');
  if (!widgets.length) return;

  var currentScale = 1;
  var panX = 0;
  var panY = 0;
  var lastDist = 0;
  var isDragging = false;
  var dragStartX = 0;
  var dragStartY = 0;
  var dragStartPanX = 0;
  var dragStartPanY = 0;

  widgets.forEach(function (container) {
    const productId = container.dataset.productId;
    const formData = window.ADVISORY_FORM && window.ADVISORY_FORM[productId];
    if (!formData || !formData.steps || !formData.start) return;

    const i18n = {
      back: container.dataset.labelBack || '← Zurück',
      continue: container.dataset.labelContinue || 'Weiter',
      errorEmpty: container.dataset.labelErrorEmpty || 'Bitte gib einen Wert ein.',
      errorInvalid: container.dataset.labelErrorInvalid || 'Ungültiger Wert. Bitte prüfe deine Eingabe.',
      stepNotFound: container.dataset.labelStepNotFound || 'Fehler: Schritt nicht gefunden.',
      unknownStep: container.dataset.labelUnknownStep || 'Unbekannter Schritttyp: '
    };

    let history = [];
    let currentStepId = null;

    function init() {
      history = [];
      currentStepId = formData.start;
      render(currentStepId);
    }

    function navigateTo(stepId) {
      history.push(currentStepId);
      currentStepId = stepId;
      render(stepId);
    }

    function goBack() {
      if (!history.length) return;
      currentStepId = history.pop();
      render(currentStepId);
    }

    function evaluateRanges(value, ranges) {
      var num = parseFloat(value);
      if (isNaN(num)) return null;
      for (var i = 0; i < ranges.length; i++) {
        var r = ranges[i];
        var min = r.min !== undefined ? r.min : -Infinity;
        var max = r.max !== undefined ? r.max : Infinity;
        if (num >= min && num <= max) return r.next;
      }
      return null;
    }

    function el(tag, className, text) {
      var e = document.createElement(tag);
      if (className) e.className = className;
      if (text !== undefined) e.textContent = text;
      return e;
    }

    function createSolidButton(label) {
      var btn = el('button', 'button button--solid button--regular', undefined);
      btn.type = 'button';
      var span = el('span', 'button__text', label);
      btn.appendChild(span);
      return btn;
    }

    function updateBackBtn() {
      var advisoryForm = container.closest('.advisory-form');
      var slot = advisoryForm && advisoryForm.querySelector('[data-advisory-form-back]');
      if (!slot) return;

      slot.innerHTML = '';
      if (!history.length) return;

      var btn = el('button', 'advisory-form__back', i18n.back);
      btn.type = 'button';
      btn.addEventListener('click', goBack);
      slot.appendChild(btn);
    }

    function getProgressActiveCount(step) {
      if (step.type === 'result') return 4;
      return Math.min(4, history.length + 1);
    }

    function renderProgressBar(step, frag) {
      var active = getProgressActiveCount(step);
      var progress = el('div', 'advisory-form__progress');
      progress.setAttribute('role', 'progressbar');
      progress.setAttribute('aria-valuemin', '0');
      progress.setAttribute('aria-valuemax', '4');
      progress.setAttribute('aria-valuenow', String(active));

      for (var i = 1; i <= 4; i++) {
        var barClass = 'advisory-form__progress-bar';
        if (i <= active) barClass += ' advisory-form__progress-bar--active';
        progress.appendChild(el('span', barClass));
      }

      frag.appendChild(progress);
    }

    function renderImage(src, alt, frag) {
      if (!src) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'advisory-form__image-wrapper';

      var img = document.createElement('img');
      img.src = src;
      img.alt = alt || '';
      img.loading = 'lazy';
      img.className = 'advisory-form__step-image';

      var zoomBtn = document.createElement('button');
      zoomBtn.type = 'button';
      zoomBtn.className = 'advisory-form__zoom-btn';
      zoomBtn.setAttribute('aria-label', 'Bild vergrößern');
      zoomBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';

      zoomBtn.addEventListener('click', function () {
        openLightbox(src, alt);
      });

      wrapper.appendChild(img);
      wrapper.appendChild(zoomBtn);
      frag.appendChild(wrapper);
    }

    function applyTransform(img) {
      img.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + currentScale + ')';
    }

    function clampPan(img) {
      if (currentScale <= 1) {
        panX = 0;
        panY = 0;
        return;
      }
      var maxX = img.offsetWidth * (currentScale - 1) / 2;
      var maxY = img.offsetHeight * (currentScale - 1) / 2;
      panX = Math.min(Math.max(panX, -maxX), maxX);
      panY = Math.min(Math.max(panY, -maxY), maxY);
    }

    function createLightbox() {
      if (document.getElementById('advisory-lightbox')) return;

      var dialog = document.createElement('dialog');
      dialog.id = 'advisory-lightbox';
      dialog.className = 'advisory-form__lightbox';
      dialog.innerHTML =
        '<button type="button" class="advisory-form__lightbox-close" aria-label="Schließen">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<img class="advisory-form__lightbox-img" src="" alt="">';

      dialog.querySelector('.advisory-form__lightbox-close').addEventListener('click', function () {
        dialog.close();
        document.body.style.overflow = '';
      });

      dialog.addEventListener('close', function () {
        document.body.style.overflow = '';
      });

      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) {
          dialog.close();
          document.body.style.overflow = '';
        }
      });

      var lightboxImg = dialog.querySelector('.advisory-form__lightbox-img');

      lightboxImg.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          isDragging = false;
          lastDist = Math.hypot(
            e.touches[0].pageX - e.touches[1].pageX,
            e.touches[0].pageY - e.touches[1].pageY
          );
        } else if (e.touches.length === 1 && currentScale > 1) {
          isDragging = true;
          dragStartX = e.touches[0].pageX;
          dragStartY = e.touches[0].pageY;
          dragStartPanX = panX;
          dragStartPanY = panY;
        }
      }, { passive: true });

      lightboxImg.addEventListener('touchmove', function (e) {
        e.preventDefault();
        if (e.touches.length === 2) {
          var dist = Math.hypot(
            e.touches[0].pageX - e.touches[1].pageX,
            e.touches[0].pageY - e.touches[1].pageY
          );
          var midX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
          var midY = (e.touches[0].pageY + e.touches[1].pageY) / 2;
          var newScale = Math.min(Math.max(currentScale * (dist / lastDist), 1), 4);
          var scaleDelta = newScale / currentScale;

          var cX = window.innerWidth / 2;
          var cY = window.innerHeight / 2;
          panX = (midX - cX) * (1 - scaleDelta) + panX * scaleDelta;
          panY = (midY - cY) * (1 - scaleDelta) + panY * scaleDelta;

          currentScale = newScale;
          clampPan(lightboxImg);
          applyTransform(lightboxImg);
          lastDist = dist;
        } else if (e.touches.length === 1 && isDragging) {
          panX = dragStartPanX + (e.touches[0].pageX - dragStartX);
          panY = dragStartPanY + (e.touches[0].pageY - dragStartY);
          clampPan(lightboxImg);
          applyTransform(lightboxImg);
        }
      }, { passive: false });

      lightboxImg.addEventListener('touchend', function () {
        isDragging = false;
        lastDist = 0;
        if (currentScale < 1.05) {
          currentScale = 1;
          panX = 0;
          panY = 0;
          applyTransform(lightboxImg);
        }
      });

      document.body.appendChild(dialog);
    }

    function openLightbox(src, alt) {
      var dialog = document.getElementById('advisory-lightbox');
      if (!dialog) return;
      var img = dialog.querySelector('.advisory-form__lightbox-img');
      img.src = src;
      img.alt = alt || '';
      currentScale = 1;
      panX = 0;
      panY = 0;
      img.style.transform = '';
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }

    function renderChoice(step, frag) {
      if (step.title) frag.appendChild(el('h3', 'advisory-form__step-title', step.title));
      if (step.text) frag.appendChild(el('p', 'advisory-form__step-text', step.text));
      renderImage(step.image, step.image_alt || step.title, frag);

      var opts = el('div', 'advisory-form__options');
      step.options.forEach(function (option) {
        var btn = el('button', 'advisory-form__option-btn', option.label);
        btn.type = 'button';
        btn.addEventListener('click', function () {
          navigateTo(option.next);
        });
        opts.appendChild(btn);
      });
      frag.appendChild(opts);
    }

    function renderNumberInput(step, frag) {
      if (step.title) frag.appendChild(el('h3', 'advisory-form__step-title', step.title));
      if (step.text) frag.appendChild(el('p', 'advisory-form__step-text', step.text));
      renderImage(step.image, step.image_alt || step.title, frag);

      var group = el('div', 'advisory-form__input-group');
      var field = el('div', 'advisory-form__number-field');
      var input = document.createElement('input');
      input.type = 'number';
      input.className = 'advisory-form__number-input';
      input.placeholder = step.input_label || 'Wert eingeben';
      if (step.input_min !== undefined) input.min = step.input_min;
      field.appendChild(input);

      var unit = el('span', 'advisory-form__number-unit');
      unit.appendChild(el('span', 'advisory-form__number-unit-text', step.input_unit || 'mm'));
      field.appendChild(unit);

      group.appendChild(field);

      var error = el('p', 'advisory-form__error');
      error.setAttribute('aria-live', 'polite');

      var btn = createSolidButton(step.button_label || i18n.continue);
      btn.classList.add('advisory-form__continue-btn');
      btn.addEventListener('click', function () {
        var val = input.value.trim();
        if (!val || isNaN(parseFloat(val))) {
          error.textContent = i18n.errorEmpty;
          return;
        }
        var next = evaluateRanges(val, step.ranges);
        if (!next) {
          error.textContent = i18n.errorInvalid;
          return;
        }
        error.textContent = '';
        navigateTo(next);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') btn.click();
      });

      group.appendChild(btn);
      frag.appendChild(group);
      frag.appendChild(error);
    }

    function isElementVisible(element) {
      if (!element) return false;
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    function findNextProductBlock(advisoryForm) {
      if (!advisoryForm) return null;
      var next = advisoryForm.nextElementSibling;
      while (next) {
        if (isElementVisible(next)) return next;
        next = next.nextElementSibling;
      }
      return null;
    }

    function scrollToNextProductBlock() {
      var advisoryForm = container.closest('.advisory-form');
      var nextBlock = findNextProductBlock(advisoryForm);
      if (!nextBlock) return;
      nextBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderResultText(step, frag) {
      if (step.text_html || step.text_html_secondary) {
        if (step.text_html) {
          var primaryText = el('p', 'advisory-form__result-text');
          if (step.text_html_secondary) {
            primaryText.classList.add('advisory-form__result-text--primary');
          }
          primaryText.innerHTML = step.text_html;
          frag.appendChild(primaryText);
        }
        if (step.text_html_secondary) {
          var secondaryText = el('p', 'advisory-form__result-text advisory-form__result-text--secondary');
          secondaryText.innerHTML = step.text_html_secondary;
          frag.appendChild(secondaryText);
        }
      } else if (step.text) {
        frag.appendChild(el('p', 'advisory-form__result-text', step.text));
      }
    }

    function renderResultFooter(frag, placement) {
      var configText = container.dataset.configText || '';
      var configIcon = container.dataset.configIcon || '';
      var configIconWidth = container.dataset.configIconWidth || '32';

      if (!configText && !configIcon) return false;

      var btn = el('button', 'advisory-form__config-scroll');
      btn.type = 'button';
      btn.setAttribute('aria-label', configText || 'Weiter zur Konfiguration');

      if (placement === 'after-image') {
        btn.classList.add('advisory-form__config-scroll--after-image');
      }

      if (configText) {
        btn.appendChild(el('span', 'advisory-form__config-scroll-text', configText));
      }

      if (configIcon) {
        var img = document.createElement('img');
        img.src = configIcon;
        img.alt = '';
        img.className = 'advisory-form__config-scroll-icon';
        img.style.width = configIconWidth + 'px';
        img.loading = 'lazy';
        btn.appendChild(img);
      }

      btn.addEventListener('click', scrollToNextProductBlock);
      frag.appendChild(btn);
      return true;
    }

    function renderResultClassic(step, frag) {
      if (step.title) frag.appendChild(el('h3', 'advisory-form__step-title', step.title));
      renderResultText(step, frag);

      if (step.button && step.button.url && step.button.label) {
        var a = document.createElement('a');
        a.href = step.button.url;
        a.className = 'button button--solid button--regular advisory-form__result-btn';
        var aSpan = el('span', 'button__text', step.button.label);
        a.appendChild(aSpan);
        frag.appendChild(a);
      }

      if (step.image_title) frag.appendChild(el('p', 'advisory-form__image-title', step.image_title));
      renderImage(step.image, step.image_alt || step.title, frag);
    }

    function renderResultImageFirst(step, frag) {
      if (step.title) frag.appendChild(el('h3', 'advisory-form__step-title', step.title));
      if (step.image_title) frag.appendChild(el('p', 'advisory-form__image-title advisory-form__image-title--first', step.image_title));
      if (step.image_text) frag.appendChild(el('p', 'advisory-form__image-text', step.image_text));
      renderImage(step.image, step.image_alt || step.title, frag);
      renderResultFooter(frag, 'after-image');
      renderResultText(step, frag);
    }

    function renderResult(step, frag) {
      if (step.layout === 'image_first') {
        renderResultImageFirst(step, frag);
      } else {
        renderResultClassic(step, frag);
      }
    }

    function render(stepId) {
      var step = formData.steps[stepId];
      if (!step) {
        container.innerHTML = '<p>' + i18n.stepNotFound + '</p>';
        return;
      }

      var frag = document.createDocumentFragment();

      renderProgressBar(step, frag);

      switch (step.type) {
        case 'choice':
          renderChoice(step, frag);
          break;
        case 'number_input':
          renderNumberInput(step, frag);
          break;
        case 'result':
          renderResult(step, frag);
          break;
        default:
          frag.appendChild(el('p', '', i18n.unknownStep + step.type));
      }

      if (step.type === 'result' && step.layout !== 'image_first') {
        renderResultFooter(frag);
      }

      container.innerHTML = '';
      container.appendChild(frag);
      updateBackBtn();

      if (history.length > 0) {
        container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    createLightbox();
    init();
  });
})();
